import { Model } from '..';

export class AdunitServingScript extends Model {
  public apiPath = undefined;
  public className = 'servingScript';
  public script: string;
}
